import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import React, { useRef } from 'react'
import { ACKNOWLEDGEMENT_RESPONSE_STATE } from '../constants'
import AcknowledgementTimeline from './AcknowledgementTimeline'

const IncompleteResponse = ({ onBack = () => {}, onGoToStatus = () => {}, copy = {}, timelineSteps }) => {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap18">
      <div className="dome-d-flex dome-flex-column dome-gap6">
        <span className="dome-d-flex dome-align-center ">
          <i style={{ fontSize: '42px' }} className={clsx('fa-thin dome-color-dark-green dome-text-w500', copy.icon)}></i>
        </span>
        <span className="dome-h2 dome-color-dark-green">{copy.title}</span>
      </div>
      {copy.paragraph ? (
        <span className="dome-p1 dome-color-dark-grey">{copy.paragraph}</span>
      ) : (
        <AcknowledgementTimeline steps={timelineSteps} />
      )}
      <div className="dome-d-flex dome-justify-between">
        <button
          type="button"
          onClick={onBack}
          className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
        >
          back to requirements
        </button>
        <button type="button" onClick={onGoToStatus} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
          go to status
        </button>
      </div>
    </div>
  )
}

const CompleteResponse = ({ onGoToStatus = () => {}, onGoToShareTab = () => {}, copy = {}, timelineSteps }) => {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap18">
      <div className="dome-d-flex dome-flex-column dome-gap6">
        <span className="dome-d-flex dome-align-center ">
          <i style={{ fontSize: '42px' }} className={clsx('fa-thin dome-color-dark-green dome-text-w500', copy.icon)}></i>
        </span>
        <div className="dome-d-flex dome-flex-column">
          <span className="dome-h2 dome-color-dark-green">{copy.title}</span>
          <span className="dome-h2 dome-color-dark-green dome-text-w400">{copy.subtitle}</span>
        </div>
      </div>
      <AcknowledgementTimeline steps={timelineSteps} />
      <div className="dome-d-flex dome-justify-between">
        <button type="button" onClick={onGoToStatus} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
          go to status
        </button>
        <button type="button" onClick={onGoToShareTab} className="dome-btn dome-btn-base dome-btn-dark-green">
          go to share tab
        </button>
      </div>
    </div>
  )
}

export default function AcknowledgementSuccessModal({
  flow = ACKNOWLEDGEMENT_RESPONSE_STATE.INCOMPLETE,
  open = false,
  content = {},
  onBack = () => {},
  onGoToStatus = () => {},
  onGoToShareTab = () => {},
}) {
  const overlayRef = useRef(null)
  const success = content.success || {}
  const timeline = content.timeline || {}

  const handleClickOutsideModal = (e) => {
    if (e.target !== overlayRef.current) return
    onBack()
  }

  return (
    <Portal>
      <div className={clsx('requester-flow-modal-overlay dome-full-width dome-full-height', open && 'show')}>
        <div
          ref={overlayRef}
          onClick={handleClickOutsideModal}
          className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center"
        >
          <div style={{ padding: '36px 60px 24px 60px', background: 'white', borderRadius: 6, width: 500 }}>
            {flow === ACKNOWLEDGEMENT_RESPONSE_STATE.INCOMPLETE ? (
              <IncompleteResponse
                onBack={onBack}
                onGoToStatus={onGoToStatus}
                copy={success.incomplete}
                timelineSteps={timeline.incomplete}
              />
            ) : (
              <CompleteResponse
                onGoToStatus={onGoToStatus}
                onGoToShareTab={onGoToShareTab}
                copy={success.complete}
                timelineSteps={timeline.complete}
              />
            )}
          </div>
        </div>
      </div>
    </Portal>
  )
}
